import { n8nApiSlice } from "../../../services/api";
import { IUserPermission } from "../types";

// 使用者權限清單改由後端 Worker 下發，避免把帳號／角色／額度清單硬編進前端 bundle。
// 網址透過環境變數注入；未設定時回傳空清單，getUserRole 會 fallback 成一般 user。
const USER_PERMISSION_API_URL = import.meta.env.VITE_USER_PERMISSION_API_URL || "";

export const userPermissionApi = n8nApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUserPermissions: builder.query<IUserPermission[], void>({
            queryFn: async (_arg, _api, _extra, baseQuery) => {
                // 未設定 API 網址時，不打包任何清單，直接回空陣列（全員降為一般 user）。
                if (!USER_PERMISSION_API_URL) {
                    return { data: [] };
                }
                const result = await baseQuery({ url: USER_PERMISSION_API_URL });
                if (result.error) {
                    // 取不到清單時安全降級：回空陣列，避免阻塞登入。
                    return { data: [] };
                }
                return { data: (result.data as IUserPermission[]) ?? [] };
            },
            providesTags: ["n8n_UserPermission"],
        }),
    }),
});

export const { useGetUserPermissionsQuery } = userPermissionApi;
